'use strict';

export class DonationMultipleRecipients {
	#donationTributeWrapper;
	#isHasSwitcher;
	#donationRecipentItemsWrapper;
	#selectElement;

	constructor() {
		this.#cacheElements();
		this.#init();
	}

	#cacheElements() {
		this.#donationTributeWrapper = document.querySelector('.donation_tribute_wrapper');
		this.#isHasSwitcher = this.#donationTributeWrapper?.getAttribute('data-switcher');
		this.#donationRecipentItemsWrapper = document.querySelector('.donation_recipent_items_wrapper');
		this.#selectElement = document.getElementById('donation_tribute_multiple_recipients_select');
	}

	#init() {
		if ( ! this.#selectElement ) {
			return;
		}
		this.#selectElement.addEventListener( 'change', ( event ) => {
			this.#updateFieldsBasedOnSelection( event.target.value );
		} );
	}

	#updateFieldsBasedOnSelection( value ) {
		this.#clearAdditionalFields();

		if ( value === '2' ) {
			this.#addAdditionalFields( 1 );
		} else if ( value === '3' ) {
			this.#addAdditionalFields( 2 );
		}
	}

	#clearAdditionalFields() {
		const additionalFields = document.querySelectorAll( '.additional-donation-fields' );
		additionalFields.forEach( ( field ) => field.remove() );
	}

	#addAdditionalFields( count ) {
		if ( this.#donationTributeWrapper ) {
			this.#donationTributeWrapper.style.display = '';
		}

		let currentIndex = 1;

		const existingFields = document.querySelectorAll( '.additional-donation-fields' );
		if ( existingFields.length > 0 ) {
			return;
		}

		const sourceWrapper = document.querySelector( '.donation_tribute_items_wrapper' );
		if ( ! sourceWrapper ) {
			return;
		}

		for ( let i = 0; i < count; i++ ) {
			const clonedFields = sourceWrapper.cloneNode( true );
			clonedFields.classList.add( 'additional-donation-fields' );
			const allowMultipleEl = clonedFields.querySelector( '.allow_multiple_recipients' );
			if ( allowMultipleEl ) {
				allowMultipleEl.remove();
			}

			const inputs = clonedFields.querySelectorAll( 'input, textarea, select' );
			inputs.forEach( ( input ) => {
				if ( input.name === 'donation_tribute_multiple_recipients' && input.tagName.toLowerCase() === 'select' ) {
					input.remove();
					return;
				}
				const name = input.name;
				if ( name ) {
					input.name = input.name.replace( /\[0\]/, `[${ currentIndex }]` );
				}
				const id = input.id;
				if ( id ) {
					const newId = input.id.replace( /_0$/, `_${ currentIndex }` ) === id
						? `${ id }_${ currentIndex }`
						: input.id.replace( /_0$/, `_${ currentIndex }` );
					input.id = newId;
					const label = clonedFields.querySelector( `label[for="${ id }"]` );
					if ( label ) {
						label.setAttribute( 'for', newId );
					}
				}
				if ( input.tagName.toLowerCase() === 'select' ) {
					input.options.selectedIndex = 0;
				} else {
					input.value = '';
				}
			} );

			if ( this.#isHasSwitcher === 'true' && this.#donationRecipentItemsWrapper ) {
				const parentWrapper = this.#donationRecipentItemsWrapper.parentNode;
				if ( parentWrapper ) {
					parentWrapper.appendChild( clonedFields );
				} else {
					this.#donationRecipentItemsWrapper.appendChild( clonedFields );
				}
			} else if ( this.#donationRecipentItemsWrapper && this.#donationTributeWrapper ) {
				const recipientsCloned = this.#donationRecipentItemsWrapper.cloneNode( true );
				recipientsCloned.classList.add( 'additional-donation-fields' );

				const recipientInputs = recipientsCloned.querySelectorAll( 'input, textarea, select' );
				recipientInputs.forEach( ( input ) => {
					const name = input.name;
					if ( name ) {
						input.name = input.name.replace( /\[0\]/, `[${ currentIndex }]` );
					}
					const id = input.id;
					if ( id ) {
						input.id = input.id.replace( /_0$/, `_${ currentIndex }` );
						const label = recipientsCloned.querySelector( `label[for="${ id }"]` );
						if ( label ) {
							label.setAttribute( 'for', input.id );
						}
					}
					if ( input.tagName.toLowerCase() === 'select' ) {
						input.options.selectedIndex = 0;
					} else {
						input.value = '';
					}
				} );
				this.#donationTributeWrapper.appendChild( clonedFields );
				this.#donationTributeWrapper.appendChild( recipientsCloned );
			}
			currentIndex++;
		}
	}
}
